"use client";

import { useScrollToRef } from "@2u-landing-pages/utils";
// import { ExecEdHeaderPromoBanner } from "../components";
import { StaticBanner } from "../components/degrees/banner";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { Section1 } from "./Section1";
import { Section10 } from "./Section10";
import { Section2 } from "./Section2";
import { Section3 } from "./Section3";
import { Section4 } from "./Section4";
import { Section5 } from "./Section5";
import { Section6 } from "./Section6";
import { Section7 } from "./Section7";
import { Section8 } from "./Section8";
import { Section9 } from "./Section9";

export const MitAi = function () {
  const { ref, scrollTo } = useScrollToRef();

  return (
    <>
      <StaticBanner backgroundColor="#a31f34" />
      {/* <ExecEdHeaderPromoBanner /> */}
      <Header />
      <Hero scrollTo={scrollTo} />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 ref={ref} />
      <Footer />
    </>
  );
};
